import { gql } from '@/utilities/gql';
import { makeGqlSuspenseQuery } from '@/utilities/gqlQuery';

const QUERY = gql(`
  query GetNarrativeValuationOptions($companyId: ID!) {
    company(ref: $companyId) {
      id
      data {
        currencyInfo
      }
      analysisValue {
        priceTargetAnalystCount
      }
      name
      tickerSymbol
      valuationOptions {
        type
        valuation {
          id
          narrative {
            id
            isPrimary
          }
        }
        fairValue
        intrinsicDiscount
      }
    }
  }
`);

export const useNarrativeValuationOptions = makeGqlSuspenseQuery(QUERY);
